<route>
{
  "name": "underConstruction",
  "meta": {
    "order": 21,
    "isVisible": false,
    "iconName": "mdi-account-hard-hat",
    "artwork": "/img/samples/auth-artwork.png"
  }
}
</route>
<template>
  <UnderConstruction />
</template>
<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout
}
</script>
